module.exports = __webpack_public_path__ + "media/images/lb/776-c14581953cfa3216c8d1209eb4781386.svg";